// extracted by mini-css-extract-plugin
module.exports = {"chatattach":"whileattach_chatattach__hR4-o","chatattachinner":"whileattach_chatattachinner__36461"};